var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license-plate",class:{ large: _vm.large, 'inside-select': _vm.insideSelect }},[_c('img',{attrs:{"src":"/assets/img/dutch_license_plate.png"}}),_c('span',[_vm._v(_vm._s(_vm.formattedLicensePlate))])])}
var staticRenderFns = []

export { render, staticRenderFns }